import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=011b9bd2&"
import script from "./BaseDivider.vue?vue&type=script&lang=ts&"
export * from "./BaseDivider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports